module.exports = __webpack_public_path__ + "static/media/04.9420528f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/south-korea-two/04.jpg
// module id = 525
// module chunks = 0